var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"world-map"},[_c('svg',{ref:"svg"})])
}
var staticRenderFns = []

export { render, staticRenderFns }